module.exports = __webpack_public_path__ + "static/bannner-internacionalismo-9-634631a6530188e34bf9e0b0e82a3cad.png";